import { isDiscountItemPrice, isMemberRewardItemPrice } from '../../../sales-data/utils/items/item-price-utils';
import { getOrderItemCountByItemId } from './get-order-item-count-by-item-id';
export const getOrderItemPriceForPriceRestriction = (item, priceRestriction) => {
    const itemCount = getOrderItemCountByItemId(item.itemId, priceRestriction);
    if (!itemCount)
        return;
    // If order item exists with specified price restriction, retrieving itemPrice object from the normal item associated with the price restricted order item.
    if (priceRestriction.discountId)
        return getItemPriceByDiscountId(item, priceRestriction.discountId);
    if (priceRestriction.rewardId)
        return getItemPriceByRewardId(item, priceRestriction.rewardId);
};
const getItemPriceByDiscountId = (item, discountId) => {
    return item.prices.find(itemPrice => isDiscountItemPrice(itemPrice) && itemPrice.discountId === discountId);
};
const getItemPriceByRewardId = (item, rewardId) => {
    return item.prices.find(itemPrice => isMemberRewardItemPrice(itemPrice) && itemPrice.rewardId === rewardId);
};
